/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16.2427 7.75672C20.929 12.443 22.8285 18.1415 20.4853 20.4846M7.75745 7.75713C12.4437 3.07084 18.1422 1.17135 20.4854 3.51449C22.8285 5.85764 20.929 11.5561 16.2427 16.2424"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.4854 20.4851C18.1422 22.8282 12.4437 20.9287 7.75744 16.2424C3.07115 11.5561 1.17165 5.85764 3.5148 3.51449C5.85794 1.17135 11.5564 3.07084 16.2427 7.75713M16.2427 16.2425C11.5564 20.9288 5.85796 22.8283 3.51482 20.4851C1.17167 18.142 3.07117 12.4435 7.75746 7.75719M11.9999 12.0001H12.0099M12.4999 12.0001C12.4999 12.2763 12.2761 12.5001 11.9999 12.5001C11.7238 12.5001 11.4999 12.2763 11.4999 12.0001C11.4999 11.724 11.7238 11.5001 11.9999 11.5001C12.2761 11.5001 12.4999 11.724 12.4999 12.0001Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M7.75739 16.2427C9.12175 17.607 10.5719 18.7352 12.0001 19.5912C13.4282 18.7352 14.8784 17.607 16.2427 16.2427C17.607 14.8784 18.7352 13.4282 19.5912 12.0001C18.7352 10.5719 17.607 9.12173 16.2427 7.75738C14.8783 6.39305 13.4282 5.26492 12.0001 4.40892C10.5719 5.26493 9.12176 6.39307 7.7574 7.75743C6.39306 9.12177 5.26493 10.5719 4.40892 12.0001C5.26493 13.4282 6.39305 14.8783 7.75739 16.2427Z"
				fill="currentColor"
			/>
			<path
				d="M12 12H12.01M16.2427 7.75701C20.929 12.4433 22.8284 18.1418 20.4853 20.4849C18.1422 22.8281 12.4437 20.9286 7.75738 16.2423C3.07109 11.556 1.17159 5.85752 3.51474 3.51437C5.85788 1.17123 11.5564 3.07072 16.2427 7.75701ZM16.2427 16.2423C11.5564 20.9286 5.8579 22.8281 3.51476 20.485C1.17161 18.1418 3.07111 12.4434 7.7574 7.75706C12.4437 3.07077 18.1422 1.17128 20.4853 3.51442C22.8285 5.85757 20.929 11.5561 16.2427 16.2423ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M6.34318 6.34325C4.96668 7.71975 3.79234 9.19765 2.86606 10.689C2.64003 10.198 2.44696 9.71269 2.28847 9.23722C1.49252 6.84935 1.50371 4.4651 2.98437 2.98443C4.46504 1.50377 6.84929 1.49258 9.23715 2.28853C9.71263 2.44702 10.1979 2.64009 10.689 2.86612C9.19759 3.7924 7.71969 4.96675 6.34318 6.34325Z"
				fill="currentColor"
			/>
			<path
				d="M17.6569 17.657C16.2804 19.0334 14.8025 20.2078 13.3112 21.1341C13.8022 21.36 14.2874 21.5531 14.7628 21.7116C17.1507 22.5075 19.5349 22.4963 21.0156 21.0157C22.4963 19.535 22.5075 17.1507 21.7115 14.7629C21.553 14.2875 21.36 13.8022 21.134 13.3112C20.2077 14.8026 19.0334 16.2805 17.6569 17.657Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.7628 2.2886C17.1507 1.49265 19.535 1.50384 21.0156 2.9845C22.4963 4.46517 22.5075 6.84942 21.7115 9.23728C20.8997 11.6727 19.1806 14.3655 16.773 16.7731C14.3654 19.1807 11.6726 20.8998 9.23718 21.7116C6.84932 22.5076 4.46507 22.4964 2.9844 21.0157C1.50374 19.5351 1.49255 17.1508 2.2885 14.7629C3.10032 12.3275 4.81942 9.63477 7.22704 7.22714C9.63467 4.81952 12.3274 3.10042 14.7628 2.2886ZM12 14.0001C13.1046 14.0001 14 13.1047 14 12.0001C14 10.8955 13.1046 10.0001 12 10.0001C10.8954 10.0001 9.99998 10.8955 9.99998 12.0001C9.99998 13.1047 10.8954 14.0001 12 14.0001Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12.0001 19.5909C10.5719 18.7349 9.12179 17.6067 7.75744 16.2424C3.07115 11.5561 1.17165 5.85763 3.5148 3.51448C5.85794 1.17134 11.5564 3.07083 16.2427 7.75712C20.929 12.4434 22.8285 18.1419 20.4854 20.485C19.3138 21.6566 17.3034 21.7675 15.0002 20.9998M12.0001 4.40853C15.4774 2.32431 18.8244 1.8534 20.4854 3.51437C22.8285 5.85752 20.929 11.556 16.2427 16.2423C11.5564 20.9286 5.85796 22.8281 3.51482 20.4849C1.17167 18.1418 3.07117 12.4433 7.75746 7.75701C8.01866 7.49581 8.283 7.24327 8.54973 6.99964M11.9999 12H12.0099M12.4999 12C12.4999 12.2761 12.2761 12.5 11.9999 12.5C11.7238 12.5 11.4999 12.2761 11.4999 12C11.4999 11.7239 11.7238 11.5 11.9999 11.5C12.2761 11.5 12.4999 11.7239 12.4999 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12.0001 12.0001H12.0101M16.2427 7.75713C20.929 12.4434 22.8285 18.1419 20.4854 20.4851C18.1422 22.8282 12.4437 20.9287 7.75744 16.2424C3.07115 11.5561 1.17165 5.85764 3.5148 3.51449C5.85794 1.17135 11.5564 3.07084 16.2427 7.75713ZM16.2427 16.2425C11.5564 20.9288 5.85796 22.8283 3.51482 20.4851C1.17167 18.142 3.07117 12.4435 7.75746 7.75719C12.4437 3.0709 18.1422 1.1714 20.4854 3.51455C22.8285 5.85769 20.929 11.5562 16.2427 16.2425ZM12.5001 12.0001C12.5001 12.2763 12.2762 12.5001 12.0001 12.5001C11.7239 12.5001 11.5001 12.2763 11.5001 12.0001C11.5001 11.724 11.7239 11.5001 12.0001 11.5001C12.2762 11.5001 12.5001 11.724 12.5001 12.0001Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M14.7628 2.28848C17.1506 1.49252 19.5349 1.50372 21.0156 2.98438C22.4962 4.46504 22.5074 6.8493 21.7115 9.23716C20.8997 11.6726 19.1805 14.3653 16.7729 16.773C14.3653 19.1806 11.6726 20.8997 9.23712 21.7115C6.84926 22.5075 4.46501 22.4963 2.98434 21.0156C1.50368 19.5349 1.49249 17.1507 2.28844 14.7628C3.10026 12.3274 4.81936 9.63464 7.22698 7.22702C9.63461 4.8194 12.3273 3.10029 14.7628 2.28848Z"
				fill="currentColor"
			/>
			<path
				d="M6.34312 6.34313C4.96662 7.71963 3.79228 9.19753 2.866 10.6889C2.63997 10.1978 2.4469 9.71257 2.28841 9.23709C1.49246 6.84923 1.50365 4.46498 2.98431 2.98431C4.46498 1.50365 6.84923 1.49246 9.23709 2.28841C9.71257 2.4469 10.1978 2.63997 10.6889 2.866C9.19753 3.79228 7.71962 4.96663 6.34312 6.34313Z"
				fill="currentColor"
			/>
			<path
				d="M17.6568 17.6568C16.2803 19.0333 14.8025 20.2077 13.3111 21.1339C13.8021 21.3599 14.2873 21.553 14.7628 21.7114C17.1506 22.5074 19.5349 22.4962 21.0155 21.0155C22.4962 19.5349 22.5074 17.1506 21.7114 14.7628C21.553 14.2873 21.3599 13.8021 21.1339 13.3111C20.2077 14.8025 19.0333 16.2804 17.6568 17.6568Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9999 14C13.1045 14 13.9999 13.1046 13.9999 12C13.9999 10.8954 13.1045 9.99998 11.9999 9.99998C10.8954 9.99998 9.99992 10.8954 9.99992 12C9.99992 13.1046 10.8954 14 11.9999 14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
